/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailablePackageToAssignToMemberResponse } from '../../models/available-package-to-assign-to-member-response';

export interface GetAvailablePackagesToAssignToMember$Params {
}

export function getAvailablePackagesToAssignToMember(http: HttpClient, rootUrl: string, params?: GetAvailablePackagesToAssignToMember$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AvailablePackageToAssignToMemberResponse>>> {
  const rb = new RequestBuilder(rootUrl, getAvailablePackagesToAssignToMember.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AvailablePackageToAssignToMemberResponse>>;
    })
  );
}

getAvailablePackagesToAssignToMember.PATH = '/api/company/members/available-packages';
